import { ReduxStore } from 'store/types';

import { Filters } from '../reducers/set/filters';

function getAllFilters(state: ReduxStore): Filters {
  return state.intervention.getAll.config.filters;
}

export default getAllFilters;
